// extracted by mini-css-extract-plugin
export default {"status":"deviceProgressStatus_status__2b4IQ"};